import { Tooltip } from '@ui/components/Tooltip'
import { AskIcon } from '@ui/icons/Ask.icon'
import { DateTime } from '@ui/v2/Table/cells/DateTime'
import { VIEW_MORE_ARROW_COL_KEY } from '@ui/v2/Table/hooks/useTableSearch'
import { BaseColumn, BaseColumnCtx } from '@ui/v2/Table/types'

import { formatDate } from '@utils/date.utils'

import { ClientJourneyMapDto } from '@model/ClientJourneyMap'

import { Box } from '@shared/components/Box'

import { IBClientJourneyMapSortKeys } from './IBClientJourneyMapTable'

export type CJMColumn = BaseColumn<
  ClientJourneyMapDto,
  BaseColumnCtx,
  IBClientJourneyMapSortKeys | typeof VIEW_MORE_ARROW_COL_KEY
>

const dateColumn = (
  id: IBClientJourneyMapSortKeys | typeof VIEW_MORE_ARROW_COL_KEY,
  labelKey: string,
  field: keyof ClientJourneyMapDto
): CJMColumn => ({
  id,
  labelKey,
  getValue: (client, { t, dateFormat }) => {
    const [date, time] = formatDate(client[field] as string, { formatType: dateFormat })?.split(
      ' '
    ) ?? ['', '']
    return <DateTime date={date} time={time} t={t} />
  },
})

export const cjmColumns: CJMColumn[] = [
  {
    id: 'Name',
    labelKey: 'IB.Client name',
    visibleOnMobile: true,
    getValue: ({ name, isEmailVerified }, { t }) =>
      name || (
        <Box flex align='center' gap='x4'>
          {t('IB.Dashboard.CJM.Name Unavailable')}
          <Tooltip
            disabled={isEmailVerified}
            direction='left'
            heading={t('IB.Dashboard.CJM.Name Unavailable')}
            description={t('IB.Dashboard.CJM.Email hasn’t been yet confirmed')}
          >
            <Box flex onClick={(e) => e.preventDefault()} align='center' justify='center' p='x8'>
              <AskIcon />
            </Box>
          </Tooltip>
        </Box>
      ),
  },
  dateColumn('LinkClickedDate', 'IB.Dashboard.CJM.Link clicked', 'linkClickedDate'),
  dateColumn('RegistrationDate', 'IB.Registration Date', 'registrationDate'),
  dateColumn('EmailVerifiedDate', 'IB.Dashboard.CJM.emailVerified', 'emailVerifiedDate'),
  dateColumn('ActivatedDate', 'IB.Dashboard.CJM.activated', 'activatedDate'),
  dateColumn('FirstCompletedDepositDate', 'IB.Dashboard.CJM.FTD', 'firstCompletedDepositDate'),
  dateColumn('FirstClosedTradeDate', 'IB.Dashboard.CJM.FTT', 'firstClosedTradeDate'),
  dateColumn('LastClosedTradeDate', 'IB.Dashboard.CJM.Last Trade', 'lastClosedTradeDate'),
  {
    id: 'TotalCommission',
    labelKey: 'Commission',
    isNumeric: true,
    visibleOnMobile: true,
    getValue: ({ totalCommission }, { t, formatMoney }) =>
      totalCommission ? formatMoney?.(totalCommission) : t('N/A'),
    align: 'right',
  },
  {
    id: VIEW_MORE_ARROW_COL_KEY,
    labelKey: '',
    visibleOnMobile: true,
    align: 'center',
    width: 40,
    getValue: () => null,
  },
]
